import LayoutPages from "@/layout/Layout2";

export default [
  {
    path: "/red-voluntariado",
    component: LayoutPages,
    children: [
      {
        path: "list",
        component: () => import("@/views/redVoluntariado/List"),
      }
    ],
  },
];
